import { useMemo } from 'react';
import { FieldValues, FormState } from 'react-hook-form';

export const useSubmissionLock = <TFormValues extends FieldValues>(formState: FormState<TFormValues>) =>
    useMemo(() => formState.isValidating || formState.isSubmitting, [formState]);
